import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/students/$studentId')({
  component: StudentLayout,
  validateSearch: (search: Record<string, unknown>) => ({
    teacherId: typeof search.teacherId === 'string' ? search.teacherId : undefined,
  }),
});

function StudentLayout() {
  return <Outlet />;
}
